// 3rd party imports
import { NavWrapper } from '~/common/components/Nav/components/Styled';
import Text from '~/common/components/Texts/Text';
import { useReadOnlyContext } from '~/common/hooks/useReadOnly';

// local imports
import CategoriesNav from './CategoriesNav';

const CategoriesHeader = () => {
  const { isReadOnly } = useReadOnlyContext();

  return (
    <NavWrapper>
      <CategoriesNav />
      {isReadOnly && (
        <Text position="absolute" as="h3" right="0" top="2">
          Read Only
        </Text>
      )}
    </NavWrapper>
  );
};

export default CategoriesHeader;
